var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.yeekeeGames),function(game){return _c('div',{key:`yeekee-${game.id}`,staticClass:"mt-1 main-game-result"},[_c('div',{staticClass:"game-type"},[_c('span',{staticClass:"py-1 px-2 mx-3 white--text"},[_vm._v(_vm._s(game.name))])]),_c('YeekeeColumn',{attrs:{"game-rounds":_vm.lastGameResult(game),"disabled":""}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }